// AppBar
import React, { Component } from "react";
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { withCookies } from 'react-cookie';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import SideMenu from './SideMenu';

// AppBar
const styles = theme => ({
    root: {
        flexGrow: 1,
        marginBottom: '70px'
    },
    flex: {
        flex: 1,

        fontSize: "21px",
    },
    menuButton: {
        marginLeft: -12,
        marginRight: 0,
    },
    colorPrimary: {
        backgroundColor: "#4DABDF",
    },
    button: {
        margin: theme.spacing(),
        color: "#FFFFFF",
    },
});

class ButtonAppBar extends Component {

    constructor(props) {
        super(props);
        this.state = {
        }
    }

    render() {

        const { classes, cookies } = this.props;
        let supporterFullName = "";

        const addressFlg = cookies.get('AVAILABLE_ADDRESS');
        const nameObj = cookies.get('COMMON_NAME_OBJ');
        const headerName = addressFlg === 'TRUE' && nameObj !== undefined ? nameObj.HEADER_NAME : process.env.REACT_APP_PROJECT_NAME;

        if(cookies.get('supporterFullName') !== "" || cookies.get('supporterFullName') !== undefined){
            supporterFullName = cookies.get('supporterFullName');
        }
        return (
        <div className={classes.root}>
            <AppBar position="fixed" className={classes.colorPrimary}>
                <Toolbar>
                    <SideMenu />
                    <Typography variant="h4" color="inherit" className={classes.flex}>
                        {headerName}
                    </Typography>
                    <Typography variant="subtitle1" color="inherit">
                        {supporterFullName}
                    </Typography>
                </Toolbar>

            </AppBar>
        </div>
        );
    }
}

//値の必須検証
ButtonAppBar.propTypes = {
    classes: PropTypes.object.isRequired,
    cookies: PropTypes.object.isRequired,
};

export default withCookies(withStyles(styles)(ButtonAppBar));